import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'


type Variables = {
  id: GQL_ID
}


export const MUTATION_DELETE_COURIER_WORKSHIFT = gql`
  mutation DeleteCourierWorkShift($id: ID!) {
    deleteCourierWorkShift(id: $id)
  }
`

export const useMutateDeleteCourierWorkShift = () => useMutation<boolean, Variables>(MUTATION_DELETE_COURIER_WORKSHIFT)